import React from "react";

const SettingsHome = ({
    isDarkMode,
    toggleTheme,
    setPage,
}) => {
    return (
        <div className="settings-list">

            <div
                className="settings-item"
                onClick={() => setPage("account")}
            >
                <p>Account</p>

                <span>
                    <i className="fas fa-chevron-right" />
                </span>
            </div>

            <div className="settings-item">
                <p>Dark Mode</p>

                <label
                    className="switch"
                    onClick={(e) => e.stopPropagation()}
                >
                    <input
                        type="checkbox"
                        checked={isDarkMode}
                        onChange={toggleTheme}
                    />

                    <span className="slider round"></span>
                </label>
            </div>

        </div>
    );
};

export default SettingsHome;